import type { Item } from "../common";

export enum InsightFamiliesFilterField {
    BRAND = "FAMILY_BRAND",
    BROWSE_NODE = "FAMILY_BROWSE_NODE",
    OBJECTIVE = "FAMILY_OBJECTIVE",
}

export type InsightFamilyFieldSelections = {
    [key in InsightFamiliesFilterField]: Item[];
};
export type InsightFamilyFilterOptions = {
    [key in InsightFamiliesFilterField]: Item[];
};
